import React, { useState, useMemo } from 'react';
import checkmarkIcon from '../../assets/checkmark.svg';
import aiIcon from '../../assets/ai_icon.svg';
import { useTranslation } from 'react-i18next';
import { formatLocalizedPrice, formatLocalizedMonthlyPrice } from '../../utils/pricing';
import './plans.css';

// Base SEK prices (defined here - can be adjusted)
const BASE_PRICES = {
  plan1Monthly: 1106,
  plan1Yearly: 995, // 10% discount
  addon1: 995,      // Extra business unit
  addon2: 95,        // Extra storage
  addon3: 295,       // FSSC 22000
  addon4: 295,       // BRCGS
  addon5: 295,       // IFS
  addon6: 295,       // GlobalG.A.P.
  addon7: 95,        // EKO
  addon8: 95,        // KRAV
  addon9: 95,        // MSC
  addon10: 95,       // ASC
  addon11: 245,      // Skadedjur
  addon12: 245,      // HR
  addon13: 245,      // Arbetsmiljö
  addon14: 245,      // Brand
};

const Plans = () => {
  const [isAnnual, setIsAnnual] = useState(true);

  const togglePlan = () => {
    setIsAnnual(!isAnnual);
  };

  const { t, i18n } = useTranslation();

  // Calculate localized prices for plan1
  const plan1MonthlyPrice = useMemo(() => 
    formatLocalizedPrice(BASE_PRICES.plan1Monthly, i18n.language),
    [i18n.language]
  );
  
  const plan1YearlyPrice = useMemo(() => 
    formatLocalizedPrice(BASE_PRICES.plan1Yearly, i18n.language),
    [i18n.language]
  );

  // Calculate localized prices for all addons
  const addonPrices = useMemo(() => ({
    addon1: formatLocalizedMonthlyPrice(BASE_PRICES.addon1, i18n.language),
    addon2: formatLocalizedMonthlyPrice(BASE_PRICES.addon2, i18n.language),
    addon3: formatLocalizedMonthlyPrice(BASE_PRICES.addon3, i18n.language),
    addon4: formatLocalizedMonthlyPrice(BASE_PRICES.addon4, i18n.language),
    addon5: formatLocalizedMonthlyPrice(BASE_PRICES.addon5, i18n.language),
    addon6: formatLocalizedMonthlyPrice(BASE_PRICES.addon6, i18n.language),
    addon7: formatLocalizedMonthlyPrice(BASE_PRICES.addon7, i18n.language),
    addon8: formatLocalizedMonthlyPrice(BASE_PRICES.addon8, i18n.language),
    addon9: formatLocalizedMonthlyPrice(BASE_PRICES.addon9, i18n.language),
    addon10: formatLocalizedMonthlyPrice(BASE_PRICES.addon10, i18n.language),
    addon11: formatLocalizedMonthlyPrice(BASE_PRICES.addon11, i18n.language),
    addon12: formatLocalizedMonthlyPrice(BASE_PRICES.addon12, i18n.language),
    addon13: formatLocalizedMonthlyPrice(BASE_PRICES.addon13, i18n.language),
    addon14: formatLocalizedMonthlyPrice(BASE_PRICES.addon14, i18n.language),
  }), [i18n.language]);

  return (
    <div className="comparison-table plans-padding" id="plans" tabindex="4">
      <div className="comparison-title">
        <h2>{t('plans.title')}</h2>
        <p>{t('plans.description')}</p>
      </div>
      
      <div className="toggle-container">
        <button className={`toggle-button ${isAnnual ? 'active' : ''}`} onClick={togglePlan} tabindex="4">
          {t('plans.toggle.yearly')}
          <div className={`discount ${!isAnnual ? '' : 'active'}`}>
            <span>{t('plans.toggle.savings')}</span>
          </div>
        </button>
        <button className={`toggle-button ${!isAnnual ? 'active' : ''}`} onClick={togglePlan} tabindex="4">
          {t('plans.toggle.monthly')}
        </button>
      </div>

      <div className="plans">
      {/* <div className="plan" tabindex="4">
          <div>
            <h3>Bas</h3>
            <p className="sub-label plan-description">För verksamheter som vill säkerställa att de följer lagar & regler.</p>
            <div className="flex">
              {isAnnual ? (
                <>
                  <h4 className="inline-block line-through inactive">545 kr</h4>
                  <h4 className="inline-block">495 kr</h4>
                  <p className="sub-label inline-block">/mån</p>
                </>
              ) : (
                <>
                  <h4 className="inline-block">545 kr</h4>
                  <p className="sub-label inline-block">/mån</p>
                </>
              )}
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">Övrigt</p>
              <ul className="plan-features">
              <li><img src={aiIcon} alt="Checkmark Icon" className="checkmark-icon" /><span className='bold'>Standard </span>AI</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" /><span className='bold'>5 st</span> användare</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Filhantering med <span className='bold'>1 TB</span> lagringsutrymme</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" /><span className='bold'>Standard</span> support</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Tillgängligt innehåll<span className='bold'> Safe & legal</span></li>
              </ul>
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">Huvudfunktioner</p>
              <ul className="plan-features">
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Översikt av din verksamhets processer & flöden</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Riskhantering & HACCP plan</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Övervakning med skräddarsydda kontroller</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Avvikelsehantering</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Rutin- & dokumentstyrning</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Leverantörs- & certifikatshantering</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Spårbarhet & historik</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Skapa rapporter - faroanalys, farostyrningsplan m.fl.</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Egenkontroll</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Säkerhet & backup</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Alltid uppdaterat</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />Använd på alla plattformar</li>
              </ul>
            </div>
            <div className="divider"></div>
            <div className="plan-section">
              <p className="sub-label tiny">Tillägg</p>
              <ul className="plan-features">
              <ul className="addons-features">
                <li>1 till Affärsenhet<span className="price-small"><span>• </span>295 kr/mån</span></li>
                <li>1 TB extra lagringsutrymme<span className="price-small"><span>• </span>99 kr/mån</span></li>
                <li>HR-paket<span className="price-small"><span>• </span>249 kr/mån</span></li>
                <li>Arbetsmiljö-paket<span className="price-small"><span>• </span>249 kr/mån</span></li>
                <li>Skadedjurs-paket<span className="price-small">*</span></li>
                <li>KRAV<span className="price-small"><span>• </span>99 kr/mån</span></li>
                <li>EKO<span className="price-small"><span>• </span>99 kr/mån</span></li>
                <li>MSC / ASC<span className="price-small"><span>• </span>99 kr/mån</span></li>
              </ul>
              </ul>
            </div>
            <div className="plan-section">
               <p className="sub-label tiny">Konsultation</p>
               <ul className="addons-features">
                 <li>Få stöd av våra livsmedelsexperter med över 100 års kombinerad erfarenhet<span className="price-small">*</span></li>
                 <br></br>
                 <p className="sub-label explainer">*Kontakta oss för offert</p>
               </ul>
             </div>
          </div>
          <br></br>
          <div className="plan-button">
            <a tabindex="4" href="/contact" className="button-secondary">Kontakta oss</a>
          </div>
        </div> */}
        <div className="plan recommended" tabindex="4">
          <div>
            <h3 className="highlighted">{t('plans.plan1.title')}</h3>
            <p className="sub-label plan-description">{t('plans.plan1.description')}</p>
            <div className="baseline flex">
              {isAnnual ? (
                <>
                  <h4 className="inline-block line-through inactive">{plan1MonthlyPrice}</h4>
                  <h4 className="inline-block">{plan1YearlyPrice}</h4>
                  <p className="sub-label inline-block no-margin-top">{t('plans.common.VAT')}</p>
                </>
              ) : (
                <>
                  <h4 className="inline-block">{plan1MonthlyPrice}</h4>
                  <p className="sub-label inline-block no-margin-top">{t('plans.common.VAT')}</p>
                </>
              )}
            </div>
            <div className="plan-section">
              {/* <p className="sub-label tiny">Övrigt</p> */}
              <ul className="plan-features">
                <li><img src={aiIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp1.item')} <span className='bold'>{t('plans.plan1.planUsp1.value')} </span></li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp2.item')} <span className='bold'>{t('plans.plan1.planUsp2.value')}</span></li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp3.item')} <span className='bold'>{t('plans.plan1.planUsp3.value')}</span></li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp4.item')} <span className='bold'>{t('plans.plan1.planUsp4.value')}</span></li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp5.item')} <span className='bold'>{t('plans.plan1.planUsp5.value')}</span></li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp6.item')} <span className='bold'>{t('plans.plan1.planUsp6.value')}</span></li>
              </ul>
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">{t('plans.plan1.section1')}</p>
              <ul className="plan-features">
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp7.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp8.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp9.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp10.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp11.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp12.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp13.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp14.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp15.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp16.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp17.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan1.planUsp18.item')}</li>
                <br></br>
                <p className="sub-label explainer">{t('plans.plan1.explanation1')}</p>
              </ul>
            </div>
          </div>
          <br></br>
          <div className="plan-button">
            {isAnnual ? (
                <a tabindex="4" href="https://buy.stripe.com/eVadRc0iIaV562s002?locale=sv" className="button-primary">{t('common.subscribeNow')}</a>
              ) : (
                <a tabindex="4" href="https://buy.stripe.com/eVa00me9yaV59eE147?locale=sv" className="button-primary">{t('common.subscribeNow')}</a>
              )}
          </div>
        </div>
        
        <div className="plan"  tabindex="4">
          <div>
            <h3>{t('plans.plan2.title')}</h3>
            <p className="sub-label plan-description">{t('plans.plan2.description')}</p>
            <div>
              <h4 className="inline-block">{t('plans.plan2.price.priceOrg')}</h4>
            </div>
            <div className="plan-section">
              <ul className="plan-features">
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan2.planUsp1.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan2.planUsp2.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan2.planUsp5.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan2.planUsp3.item')}</li>
                <li><img src={checkmarkIcon} alt="Checkmark Icon" className="checkmark-icon" />{t('plans.plan2.planUsp4.item')} <span className='bold'>{t('plans.plan2.planUsp4.value')}</span></li>
              </ul>
            </div>
          </div>
          <div className="plan-button">
            <a tabindex="4" href="/contact" className="button-secondary">{t('common.contactUs')}</a>
          </div>
        </div>

        <div className="plan"  tabindex="4">
          <div>
            <h3>{t('plans.addons.title')}</h3>
            <div className="plan-section">
              <p className="sub-label tiny">{t('plans.addons.section1')}</p>
              <ul className="addons-features">
                <li>
                  {t('plans.addons.addon1.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon1}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon2.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon2}
                  </span>
                </li>
              </ul>
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">{t('plans.addons.section2')}</p>
              <ul className="addons-features">
                <li>
                  {t('plans.addons.addon3.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon3}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon4.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon4}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon5.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon5}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon6.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon6}
                  </span>
                </li>
              </ul>
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">{t('plans.addons.section3')}</p>
              <ul className="addons-features">
                <li>
                  {t('plans.addons.addon7.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon7}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon8.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon8}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon9.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon9}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon10.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon10}
                  </span>
                </li>
              </ul>
            </div>
            <div className="plan-section">
              <p className="sub-label tiny">{t('plans.addons.section4')}</p>
              <ul className="addons-features">
                <li>
                  {t('plans.addons.addon11.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon11}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon12.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon12}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon13.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon13}
                  </span>
                </li>
                <li>
                  {t('plans.addons.addon14.item')}
                  <span className="price-small">
                    <span>• </span>
                    +{addonPrices.addon14}
                  </span>
                </li>
              </ul>
            </div>

            <br></br>
            <p className="sub-label explainer">{t('plans.addons.explanation1')}</p>
            <p className="sub-label explainer">{t('plans.addons.explanation2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
